import React, { useState } from 'react';
import { db, auth } from '../../firebase/config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function SupportWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle'); // idle, submitting, success

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!auth.currentUser) return alert("You must be logged in to contact support.");
    if (!subject || !message) return alert("Please fill out both fields.");

    setStatus('submitting');

    try {
      await addDoc(collection(db, 'support_tickets'), {
        userId: auth.currentUser.uid,
        userEmail: auth.currentUser.email,
        subject,
        message,
        status: 'open',
        createdAt: serverTimestamp()
      });
      setStatus('success');
      setTimeout(() => {
        setIsOpen(false);
        setStatus('idle');
        setSubject('');
        setMessage('');
      }, 3000);
    } catch (error) {
      console.error("Error submitting ticket:", error);
      alert("Failed to send message. Please try again.");
      setStatus('idle');
    }
  };

  return (
    <div style={{ position: 'fixed', bottom: '30px', right: '30px', zIndex: 1000 }}>
      {/* The Chat Window */}
      {isOpen && (
        <div style={{ width: '320px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.2)', marginBottom: '15px', overflow: 'hidden', border: '1px solid #eee' }}>
          <div style={{ backgroundColor: '#1a1a1a', color: 'white', padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, fontSize: '16px' }}>Contact Support</h3>
            <button onClick={() => setIsOpen(false)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' }}>✕</button>
          </div>
          
          <div style={{ padding: '20px' }}>
            {status === 'success' ? (
              <div style={{ textAlign: 'center', color: '#28a745', padding: '20px 0' }}>
                <span style={{ fontSize: '40px', display: 'block', marginBottom: '10px' }}>✅</span>
                <strong>Message Sent!</strong>
                <p style={{ margin: '10px 0 0 0', fontSize: '14px', color: '#666' }}>We will get back to you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>Experiencing an issue or have a question? Let us know.</p>
                <input 
                  type="text" 
                  placeholder="Subject (e.g. Refund Request)" 
                  value={subject}
                  onChange={e => setSubject(e.target.value)}
                  style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '14px' }}
                />
                <textarea 
                  placeholder="How can we help?" 
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  rows="4"
                  style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '14px', resize: 'none' }}
                />
                <button 
                  type="submit" 
                  disabled={status === 'submitting'}
                  style={{ padding: '12px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: status === 'submitting' ? 'not-allowed' : 'pointer' }}
                >
                  {status === 'submitting' ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* The Floating Button */}
      {!isOpen && (
        <button 
          onClick={() => setIsOpen(true)}
          style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#1a1a1a', color: 'white', border: 'none', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', fontSize: '24px', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', transition: 'transform 0.2s' }}
          onMouseOver={e => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
        >
          💬
        </button>
      )}
    </div>
  );
}